import {
  getNodeCustomerAccess,
  normalizeAccessValue,
} from "../../../utils/staffCustomerAccess";

const getCustomerName = (customer = {}) => {
  const thaiName = normalizeAccessValue(
    customer.CustomerNameTH || customer.customerNameTH,
  );
  const englishName = normalizeAccessValue(
    customer.CustomerNameEN || customer.customerNameEN,
  );

  if (thaiName && englishName && thaiName !== englishName) {
    return `${thaiName} / ${englishName}`;
  }

  return thaiName || englishName || normalizeAccessValue(customer.name);
};

const buildCustomerInfo = (customerId, customerById) => {
  const normalizedCustomerId = normalizeAccessValue(customerId);
  const customer = customerById.get(normalizedCustomerId);
  const customerName = customer ? getCustomerName(customer) : "";

  return {
    id: normalizedCustomerId,
    name: customerName || normalizedCustomerId,
    isMissing: !customer,
  };
};

export const buildAccountCustomerAccessRows = (adminData, nodes) =>
  (Array.isArray(nodes) ? nodes : []).map((node) => {
    const nodeCode = normalizeAccessValue(node && node.nodecode);
    const nodeName = normalizeAccessValue(node && node.nodename) || nodeCode;
    const customers = Array.isArray(node && node.customers)
      ? node.customers
      : [];
    const customerById = new Map(
      customers
        .map((customer) => [
          normalizeAccessValue(customer && customer.id),
          customer,
        ])
        .filter(([customerId]) => Boolean(customerId)),
    );
    const access = getNodeCustomerAccess(adminData, nodeCode);
    const customerIds =
      access.mode === "all"
        ? Array.from(customerById.keys())
        : access.customerIds;
    const visibleCustomers = customerIds
      .map((customerId) => buildCustomerInfo(customerId, customerById))
      .filter((customer) => Boolean(customer.id))
      .sort((first, second) =>
        first.name.localeCompare(second.name, "th", {
          sensitivity: "base",
        }),
      );

    return {
      nodeCode,
      nodeName,
      mode: access.mode,
      isLegacyDefault: access.isLegacyDefault,
      customers: visibleCustomers,
    };
  });

